/* eslint-disable camelcase */
import { Component, createRef, Fragment } from 'react'
import { connect } from 'react-redux'
import { Form, FormSpy } from 'react-final-form'
import { FORM_ERROR } from 'final-form'
import get from 'lodash/get'

import arrayMutators from 'final-form-arrays'
import LeadBookerInfo from './LeadBookerInfo'
import OtherParticipants from './OtherParticipants'
import { FormattedMessage } from 'react-intl'
import FormCheckbox from '../forms/final-form-fields/FormCheckbox'
import { createUrl } from '../../localized-urls'
import store from 'store2'
import API from '../../api'
import Loader from '../helpers/Loader'
import adventureCheckoutValidate from './adventureCheckoutValidate'
import AdventureRequirementsPopup from '../popups/AdventureRequirementsPopup'
import CheckoutPayments from './CheckoutPayments'
import { getOffset, getDefaultMeasurementUnits, getCookie, isWechat, getWeChatAuthUrl, CN_CODE } from 'utils'
import { connectCaptcha, makeKey, parseQuery } from '../../utils'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import WechatNativePayment from './WechatNativePayment'
import { trackGA4Ecommerce } from '../../gtm'
import { pushToVwo } from '../../vwo'
import { convertCurrency } from '../helpers'

class CheckoutAdventureForm extends Component {
  constructor() {
    super()
    this.paymentRef = createRef(null)
    this.phoneRef = createRef()
    this.preferedUnits = getDefaultMeasurementUnits()
    this.state = {
      user: store('user') || {},
      isLoading: false,
      selectedMethod: '',
      wechatCodeUrl: '',
    }
  }

  componentDidMount() {
    const { countryCode } = this.props
    connectCaptcha('captcha', countryCode)
  }

  generateParticipants() {
    const { participants } = this.props
    return Array.from(Array(participants), (k, index) => {
      return index === 0
        ? this.getUserInfo()
        : {
          ...this.preferedUnits,
        }
    })
  }

  getUserInfo() {
    const { user } = this.state
    const { extraInfo } = this.props
    if(user) {
      const contactInformation = get(user, 'contactInformation', {})
      const diveGearRentalInfo = get(user, 'diveGearRentalInfo', {})
      const diveExperience = get(user, 'diveExperience', {})
      return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        countryId: user.countryId,
        hasIncludedTransfers: extraInfo.hasIncludedTransfers,
        ...this.preferedUnits,
        ...contactInformation,
        ...diveGearRentalInfo,
        ...diveExperience,
        phone: contactInformation && contactInformation.phoneMobile,
        certifyingAgency: diveExperience && diveExperience.certifyingAgencyId,
        heightUnit: diveGearRentalInfo && diveGearRentalInfo.distanceHeightUnit,
      }
    }
    return { ...this.preferedUnits }
  }

  openRequirements = (e) => {
    e.stopPropagation()
    e.preventDefault()
    this.setState({
      isRequirementsVisible: true,
    })
  }

  hideRequirements = () => {
    this.setState({
      isRequirementsVisible: false,
    })
  }

  setSelectedMethod = (method) => {
    this.setState({
      selectedMethod: method,
    })
  }

  bookNow = (values) => {
    const {
      totalPrice,
      toBePaidOffline,
      activity,
    } = this.props
    const recaptcha = window.grecaptcha && window.grecaptcha.getResponse()
    if(!recaptcha) {
      return toast.error('Captcha is required', { position: 'top-center' })
    }
    this.setState({ isLoading: true })
    values.recaptcha = makeKey(recaptcha)
    if(!totalPrice || toBePaidOffline || values.paymentMethodId) {
      return this.checkout(values)
    }
    if(!this.paymentRef.current) {
      this.setState({ isLoading: false })
      return {
        [FORM_ERROR]: [
          <FormattedMessage
            id='select_payment'
            defaultMessage='You must select a payment method to proceed'
          />,
        ],
      }
    }
    if(this.paymentRef.current && this.state.selectedMethod === 'wechat') {
      values.paymentMethodBrand = this.state.selectedMethod
      return this.checkout(values)
    }
    return this.paymentRef.current
      .createSource()
      .then(({ source }) => {
        if(!values.nameOnCard) {
          this.setState({ isLoading: false })
          return {
            nameOnCard: (
              <FormattedMessage
                id='required_field'
                defaultMessage='This field is required!'
              />
            ),
          }
        }
        if(!source.id) {
          this.setState({ isLoading: false })
          return false
        }

        values.stripeSourceId = source.id
        values.paymentMethodBrand = source.card.brand
        return this.checkout(values)
      })
      .catch((error) => {
        window.grecaptcha?.reset()
        this.setState({ isLoading: false })
        if(error === 'No form') {
          return {
            [FORM_ERROR]: [
              <FormattedMessage
                id='select_payment'
                defaultMessage='You must select a payment method to proceed'
              />,
            ],
          }
        }
      })
  }

  checkout(values) {
    const query = parseQuery() || {}
    const { activity, totalPrice } = this.props
    const adventureAid = getCookie('padi_aid')
    if(adventureAid) {
      values.affiliateId = adventureAid
    }

    if(window.isWidget) {
      values.orderSource = this.props.widgetSource || 'widget'
    }
    if(query.social_link === 'true') {
      values.orderSource = 'social'
    }
    if(query.source) {
      values.orderSource = query.source
    }
    values.returnUrl = `${window.location.origin}${window.location.pathname}`

    return API('/api/adventure/v1/checkout/orders/', false, false, true)
      .post(values)
      .then((val) => {
        if(values.paymentMethodBrand) {
          if(values.paymentMethodBrand === 'wechat') {
            const postValues = {
              description: activity.title,
              outTradeNo: val.reference,
              total: totalPrice.originalPrice.value * 100,
            }
            if(isWechat()) {
              postValues.redirectUrl = window.location.href
              postValues.email = values.email
              window.location.href = getWeChatAuthUrl(postValues)
            } else {
              this.setState({
                wechatCodeUrl: val.wechatNativePayUrl,
              }, () => {
                this.loopQuery(val.reference, values.email)
              })
            }
            return
          }

          trackGA4Ecommerce(
            'add_payment_info',
            {
              ...store.session('ga4Cart'),
            },
            'PADI Travel - Adventures',
          )
          pushToVwo('purchase', {
            'revenue': Number(convertCurrency(this.props.totalPrice?.originalPrice?.value,
              this.props.totalPrice?.originalPrice?.currency, 'USD').toFixed(2)),
          }, true)
          window.dataLayer.push({
            event: 'checkoutOption',
            ecommerce: {
              checkout_option: {
                actionField: {
                  step: 1,
                  option: `Card - ${
                    values.paymentMethodBrand === 'MasterCard'
                      ? 'Mastercard'
                      : values.paymentMethodBrand
                  }`,
                },
              },
            },
          })
        }
        store.session('ecommerce', this.props.ecommerce)

        if(val.confirmUrl) {
          window.location.href = val.confirmUrl
        } else if(this.props.onSubmitSuccess) {
          this.props.onSubmitSuccess({
            reference: val.reference,
            email: values.email,
          })
        }
      })
      .catch(({ error }) => {
        window.grecaptcha?.reset()
        if(error && error.nonFieldErrors) {
          return { [FORM_ERROR]: error.nonFieldErrors }
        }
        if(error && error.nonFieldError) {
          return { [FORM_ERROR]: [error.nonFieldError] }
        }
        if(error[this.props.activityId]) {
          return {
            [FORM_ERROR]: Object.values(error).map((item) =>
              Object.values(item),
            )[0],
          }
        }
        return error
      })
      .finally(() => {
        if(values.paymentMethodBrand && values.paymentMethodBrand === 'wechat') { return }
        this.setState({ isLoading: false })
      })
  }

  loopQuery(outTradeNo, email) {
    API('/api/wxPay/native', false, false, false, false, true)
      .get({ outTradeNo })
      .then((data) => {
        if(data.tradeState === 'SUCCESS') {
          this.props.onSubmitSuccess({
            reference: outTradeNo,
            email: email,
          })
        } else {
          let timer = setTimeout(() => {
            this.loopQuery(outTradeNo, email)
          }, 2000)
        }
      })
      .catch(({ error }) => {
        return error
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleSubmitFailed() {
    setTimeout(() => {
      const error = document.querySelector('.error-field')
      if(error) {
        window.scrollTo(0, getOffset(error).top)
      }
    }, 150)
  }

  closeQrcodeLayer = () => {
    this.setState({ wechatCodeUrl: '' }, () => {
      window.grecaptcha?.reset()
    })
  }

  setPhoneRef = (instance) => {
    this.phoneRef.current = instance
  }

  render() {
    const {
      isLoading,
      isRequirementsVisible,
      wechatCodeUrl,
    } = this.state
    const {
      participants,
      activityId,
      activityDateTime,
      activity,
      extraInfo,
      includedTransfer,
      includedFood,
      includedRental,
      totalPrice,
      toBePaidOffline,
      extraOptions,
      shop,
    } = this.props
    const initialValues = {
      ...this.getUserInfo(),
      pickupPoints: activity.pickupPoints.length,
      productType: get(activity, 'activitySubtype.value', activity.productType),
      isNonExperienced: activity.isNonExperienced,
      includedTransfer,
      paymentMethodId: null,
      paymentMethodBrand: null,
      trips: [
        {
          activityId,
          date: activityDateTime?.split(' ')[0],
          quantity: participants,
          travelers: this.generateParticipants(),
          additionalExtraOptions: extraOptions,
        },
      ],
    }

    return (
      <div className={`main-form ${isLoading
        ? 'react-app-loading'
        : ''}`}
      >
        <Loader />
        {wechatCodeUrl && (
          <WechatNativePayment
            codeUrl={wechatCodeUrl}
            totalPrice={totalPrice.originalPrice.value}
            hideQrCode={this.closeQrcodeLayer}
          />
        )}
        <AdventureRequirementsPopup
          requirements={activity.packageOptionsRequirements}
          isOpen={isRequirementsVisible}
          closeModal={this.hideRequirements}
        />
        <Form
          onSubmit={this.bookNow}
          validate={(values) =>
            adventureCheckoutValidate(values, this.phoneRef.current, activity?.isElearning)
          }
          mutators={{
            ...arrayMutators,
          }}
          keepDirtyOnReinitialize
          initialValues={initialValues}
          render={({
            handleSubmit,
            values,
            form,
            submitError,
          }) => (
            <form onSubmit={handleSubmit}>
              <FormSpy
                subscription={{ submitFailed: true }}
                onChange={this.handleSubmitFailed}
              />
              <LeadBookerInfo setPhoneRef={this.setPhoneRef} countryCode={this.props.countryCode} />
              <OtherParticipants
                extraInfo={extraInfo}
                form={form}
                values={values}
                activity={activity}
                includedFood={includedFood}
                includedTransfer={includedTransfer}
                includedRental={includedRental}
              />
              {!!totalPrice?.chargePrice && !toBePaidOffline && (
                <Fragment>
                  <p className='section-title'>
                    <FormattedMessage
                      id='payment_options'
                      defaultMessage='Payment options'
                    />
                  </p>
                  <div className='shadow-block'>
                    <CheckoutPayments
                      paymentRef={this.paymentRef}
                      change={form.change}
                      setSelectedMethod={this.setSelectedMethod}
                      shop={shop}
                      isAdventure
                    />
                  </div>
                </Fragment>
              )}
              <div className='checkout-footer'>
                <FormCheckbox
                  name='isTermsAccepted'
                  className='mbn'
                  label={
                    <FormattedMessage
                      id='padi_terms_accept'
                      defaultMessage='I accept PADI Travel <a>Terms and conditions</a>'
                      values={{
                        a: (chunks) => (
                          <a href={createUrl('terms')} target='_blank'>
                            {chunks}
                          </a>
                        ),
                      }}
                    />
                  }
                />
                <FormCheckbox
                  name='isTermsAcceptedDc'
                  className='mtm mbh'
                  label={
                    <FormattedMessage
                      id='padi_terms_accept_dc'
                      values={{
                        requirements: (
                          <a onClick={this.openRequirements}>
                            <FormattedMessage
                              id='requirements'
                              defaultMessage='Requirements'
                            />
                          </a>
                        ),
                      }}
                      defaultMessage='I have read and meet the {requirements} set by the dive center for this activity'
                    />
                  }
                />
                {this.paymentRef.current && countryCode !== CN_CODE && (
                  <FormCheckbox
                    name='saveCreditCard'
                    className='mtm mbh'
                    label={
                      <FormattedMessage
                        id='save_cc_for_future'
                        defaultMessage='Save my card details for future use'
                      />
                    }
                  />
                )}
                {submitError && (
                  <div className='warning-message mtm mbh'>
                    {submitError.map((error) => (
                      <p key={error} className='mbn'>
                        {error}
                      </p>
                    ))}
                  </div>
                )}
                {/* {currency !== 'CNY' && <div className='mbm'>
                  <div id='captcha' />
                </div>} */}
                <div id='captcha' />
                <div className='btn-wrap'>
                  <button className='btn-red'>
                    <FormattedMessage id='book_now' defaultMessage='Book now' />
                  </button>
                </div>
              </div>
            </form>
          )}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ totalPrice }) => ({
  totalPrice,
})

export default connect(mapStateToProps)(CheckoutAdventureForm)

CheckoutAdventureForm.propTypes = {
  activity: PropTypes.object,
  activityDateTime: PropTypes.string,
  activityId: PropTypes.string,
  ecommerce: PropTypes.object,
  extraInfo: PropTypes.object,
  extraOptions: PropTypes.array,
  includedFood: PropTypes.bool,
  includedRental: PropTypes.bool,
  includedTransfer: PropTypes.bool,
  onSubmitSuccess: PropTypes.func,
  participants: PropTypes.number,
  toBePaidOffline: PropTypes.bool,
  totalPrice: PropTypes.number,
  widgetSource: PropTypes.string,
  countryCode: PropTypes.string,
}
